export const PARTNER_ORG = 'partner_orgs';
export const COMPANY = 'companies';
export const PERSON = 'people';
export const POPULATION = 'populations';
export const SUGGESTION = 'suggested';

export const RESULT_TYPES = [
  PARTNER_ORG,
  COMPANY,
  PERSON,
  POPULATION,
  SUGGESTION,
];
